import { useParams, useNavigate } from "react-router-dom";
import { useContext } from "react";
import { PageTitle } from "../../components/PageTitle";
import { GenericChat } from "../../components/shared/chat";
import { createAdapter } from "../../components/shared/chat";
import { MainContainer } from "../../components/shared/chat";
import { useSmartSessionLoader } from "../../components/shared/chat";
import { AuthContext } from "../../context/AuthContext";
import { AiPreview } from "../aiPreview/AiPreview";

export const JobCoach = () => {
    const { sessionId } = useParams<{ sessionId: string }>();
    const navigate = useNavigate();
    const adapter = createAdapter('jobCoach');

    const { canAccess } = useContext(AuthContext);
    const hasActiveSubscription = canAccess('job-coach');

    const { resolvedSessionId, isLoading } = useSmartSessionLoader('job_coach', sessionId || null);

    const handleSessionChange = (newSessionId: string) => {
        if (!newSessionId) {
            console.warn('handleSessionChange called with empty sessionId');
            return;
        }
        navigate(`/job-coach/${newSessionId}`, { replace: true });
    };

    const handleNewSession = () => {
        navigate('/job-coach', { replace: true });
    };

    if (isLoading) {
        return (
            <div>
                <PageTitle title="Job Coach" />
                <MainContainer>
                    <div style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: '50vh',
                        flexDirection: 'column',
                        gap: '16px'
                    }}>
                        <div style={{ fontSize: '16px', color: '#666' }}>
                            Lade letzte Job Coach-Sitzung...
                        </div>
                    </div>
                </MainContainer>
            </div>
        );
    }

    return (
        <div>
            <PageTitle title="Job Coach" />
            <div>
                <MainContainer>
                    <div style={{ position: 'relative', height: '100%' }}>
                        {!hasActiveSubscription && (
                            <div style={{
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                zIndex: 99,
                            }}>
                                    <AiPreview />
                            </div>
                        )}
                        <GenericChat
                            adapter={adapter}
                            hasActiveSubscription={hasActiveSubscription}
                            useTextArea={true}
                            placeholder="Erzählen Sie mir von Ihren Karrierezielen..."
                            loadingText="Job Coach schreibt..."
                            loginPrompt="Bitte melden Sie sich an, um Ihre Job-Coaching-Sitzung zu starten."
                            showSidebar={true}
                            onSessionChange={handleSessionChange}
                            initialSessionId={resolvedSessionId}
                            onNewSession={handleNewSession}
                            conversationType="job_coach"
                        />
                    </div>
                </MainContainer>
            </div>
        </div>
    );
};
